import { ApproveConsumptionModal } from "./ApproveConsumptionModal";

export default ApproveConsumptionModal;
